/** Structured TanStack Query keys for the loyalty feature. */

export const LOYALTY_ROOT_KEY = 'loyalty';

export const loyaltyKeys = {
  all: [LOYALTY_ROOT_KEY] as const,
  tiers: [LOYALTY_ROOT_KEY, 'tiers'] as const,
  rules: [LOYALTY_ROOT_KEY, 'rules'] as const,
  customer: (customerId: string) => [LOYALTY_ROOT_KEY, 'customer', customerId] as const,
  customerBonus: (customerId: string) =>
    [LOYALTY_ROOT_KEY, 'customer', customerId, 'bonus-account'] as const,
  customerTransactions: (customerId: string) =>
    [LOYALTY_ROOT_KEY, 'customer', customerId, 'transactions'] as const,
  customerTier: (customerId: string) =>
    [LOYALTY_ROOT_KEY, 'customer', customerId, 'tier'] as const,
  customerCards: (customerId: string) =>
    [LOYALTY_ROOT_KEY, 'customer', customerId, 'cards'] as const,
  customerDiscount: (customerId: string) =>
    [LOYALTY_ROOT_KEY, 'customer', customerId, 'discount'] as const,
  card: (cardNumber: string) => [LOYALTY_ROOT_KEY, 'card', cardNumber] as const,
  reservation: (referenceId: string) => [LOYALTY_ROOT_KEY, 'reservation', referenceId] as const,
  programConfig: [LOYALTY_ROOT_KEY, 'program-config'] as const,
  /** Prefix for invalidating every card-pool query regardless of filter/page. */
  cardPoolAll: [LOYALTY_ROOT_KEY, 'card-pool'] as const,
  cardPool: (params: { status?: string; page?: number; size?: number }) =>
    [LOYALTY_ROOT_KEY, 'card-pool', params] as const,
};
